<template>
	<div>
		<div class="accordion-collapse mb-4">
			<div class="accordion-collapse-item">
				<h2>
					<button class="accordion-collapse-heading collapsed" type="button" data-toggle="collapse" id="collapse1" role="button" aria-expanded="false" aria-controls="collapse" data-target="#collapse">{{ $t('filters') }}</button></h2>
				<div class="collapse multi-collapse-1" id="collapse" aria-labelledby="collapse1">
					<div class="accordion-collapse-body">
						<div class="row mt-4 mb-4">
							<div class="col-12">
								<fieldset>
									<legend>{{ $t('filter-by-date') }}</legend>
									<div class="row">
										<div class="col-md-4"><DatePicker element_class="" :label="$t('after')" :placeholder="$t('select-date')" :date="values.start_date" v-on:update="(event) => update_date(event, 'start_date')"></DatePicker></div>
										<div class="col-md-4"><DatePicker element_class="" :label="$t('before')" :placeholder="$t('select-date')" :date="values.end_date" v-on:update="(event) => update_date(event, 'end_date')"></DatePicker></div>
									</div>
								</fieldset>
							</div>
							<div class="col-12 col-md-4">
								<h3 class="h4">{{ $t('search-notices') }}</h3>
								<label for="search-notices">{{ $t('search-notices-more') }}</label>
								<input id="search-notices" type="text" class="form-control" :placeholder="$t('search-example')" v-model="values.search_notices">
								<div class="mt-4">
									<h3 class="h4">{{ $t('upcoming-notices') }}</h3>
								<div class="custom-control custom-checkbox mb-4">
									<input type="checkbox" class="custom-control-input" id="upcoming-notices" v-model="values.upcoming_notices">
									<label class="custom-control-label" for="upcoming-notices">{{ $t('upcoming-notices-more') }}</label>
								</div>
								</div>
							</div>
							<div class="col-12 col-md-4">
								<h3 class="h4">{{ $t('filter-wards') }}</h3>
								<label for="filter-wards">{{ $t('filter-wards-more') }}</label>
								<select id="filter-wards" class="form-control" v-model="values.ward">
									<option value="null">{{ $t('no-ward') }}</option>
									<option v-for="(ward_name,index) in wards" :key="index">{{ ward_name }}</option>
								</select>
								<div class="mt-4">
									<fieldset>
										<legend>{{ $t('keys.notice_type') }}</legend>
										<div class="custom-control custom-radio" v-for="(type,index) in types" :key="index">
											<input v-model="values.notice_type" type="radio" :value="type.notice_type" :id="'notice-' + type.notice_type" name="customRadio" class="custom-control-input">
											<label class="custom-control-label font-weight-normal" :for="'notice-' + type.notice_type">{{ type.notice_type }}</label>
										</div>
									</fieldset>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="filters.length || values.search_notices">
			<h3>{{ $t('current-filters') }}</h3>
			<div class="mb-4">
				<a v-if="values.ward && values.ward !=='null'" class="m-2 cursor badge badge-secondary" @click="values.ward = ''">{{ $t('ward') }}: {{ values.ward }}<i class="fal fa-times ml-2"></i></a>
				<a v-if="values.ward && values.ward === 'null'" class="m-2 cursor badge badge-secondary" @click="values.ward = ''">{{ $t('ward') }}: {{ $t('no-ward') }}<i class="fal fa-times ml-2"></i></a>
				<a v-if="values.start_date" class="m-2 cursor badge badge-secondary" @click="values.start_date = ''">{{ $t('after') }}: {{ values.start_date | moment('MMMM D, YYYY')}}<i class="fal fa-times ml-2"></i></a>
				<a v-if="values.end_date" class="m-2 cursor badge badge-secondary" @click="values.end_date = ''">{{ $t('before') }}: {{ values.end_date | moment('MMMM D, YYYY')}}<i class="fal fa-times ml-2"></i></a>
				<a v-if="values.search_notices" class="m-2 cursor badge badge-secondary" @click="values.search_notices = ''">{{ $t('containing') }}: {{ values.search_notices }}<i class="fal fa-times ml-2"></i></a>
				<a v-if="values.upcoming_notices" class="m-2 cursor badge badge-secondary" @click="values.upcoming_notices = false">{{ $t('upcoming-notices') }}<i class="fal fa-times ml-2"></i></a>
				<a v-if="values.notice_type" class="m-2 cursor badge badge-secondary" @click="values.notice_type = ''">{{ $t('keys.notice_type') }}: {{ values.notice_type }}<i class="fal fa-times ml-2"></i></a>
			</div>
		</div>
	</div>
</template>

<script>
import DatePicker from '@/components/DatePicker'
import OpenData from '@/libraries/OpenData'

	export default {
		created() {
			this.fetch_wards();
			this.fetch_types();
			this.load_filters();
		},

		props: [ 'set_upcoming_notices' ],

		components: { DatePicker },

		data() {
			return {
				values: {
					ward: '',
					start_date: '',
					end_date: '',
					search_notices: '',
					upcoming_notices: false,
					notice_type: '',
				},
				wards: [],
				types: [],
			}
		},

		watch: {
			reactive_filter_values() {
				this.$store.commit('set_filters',this.values);
			}
		},

		methods: {

			load_filters() {
				const store_filters = this.$store.getters.filter_values;
				this.values.ward = store_filters.ward || '';
				this.values.start_date = store_filters.start_date || '';
				this.values.end_date = store_filters.end_date || '';
				this.values.search_notices = store_filters.search_notices || '';
				this.values.notice_type = store_filters.notice_type || '';
				this.values.upcoming_notices = store_filters.upcoming_notices || this.set_upcoming_notices || false;
			},

			update_date(new_date,date_name) {
				this.values[date_name] = new_date;
			},

			async fetch_types() {
				let group_parameters = { select: ['notice_type'], group: ['notice_type'], function_column: 'notice_type', function: 'count'};
				const params = { group_parameters };
				this.types = await OpenData.getResults(this.$PUBLIC_NOTICES_API,params);
			},

			async fetch_wards() {
				const url = this.$WARDS_API;
				const params = { select_parameters: ['name'], order_parameters: [{key: 'name', direction: 'ASC'}]};
				const all_wards = await OpenData.getResults(url,params);
				this.wards = all_wards.map(ward => ward.name );
			},			
		},	

		computed: {
			reactive_filter_values() {
				//this returns a string that will change when any of the values change.  We then watch this computed value
				//to emit the change to whichever component is calling it
				return this.values.ward + this.values.start_date + this.values.search_notices + this.values.end_date + ((this.values.upcoming_notices) ? 'true' : 'false') + this.values.notice_type;
			},

			filters() {
				return this.$store.getters.filters;
			}
		}

	}
</script>

<style>

</style>